import "bootstrap/dist/css/bootstrap.min.css";
import {
  CitiesBox,
  CityNameList,
  CitiesBoxSubTitle,
  TopCausesBtnShow,
} from "./nearByGridStyle";

const NearByGridCause = ({ listData, title, setSelectedItem, handleChange, selectedItem }: any) => {
  return (
    <CitiesBox className="city-box-main">
      <CitiesBoxSubTitle>{title}</CitiesBoxSubTitle>
      {listData?.map((data: any, index: number) => (
        <CityNameList
          className={selectedItem?.cause === data?.slug || typeof localStorage !== "undefined" && localStorage.getItem('category') == data?.slug ? "city-name-list active" : "city-name-list"}
          key={index + 1}
          onClick={() => {
            setSelectedItem({ cause: data?.slug });
            handleChange("cause")
          }}
        >
          {title === "Nearby Cities" ? data?.city : data?.name}
        </CityNameList>
      ))}
      <TopCausesBtnShow className="top-cause-btn-show">
        <button type="button">See more...</button>
      </TopCausesBtnShow>
    </CitiesBox>
  );
};


export default NearByGridCause;